import { useAsyncCallback } from 'react-async-hook';
import { INVITE_STATUS, useInviteStore } from '../store/use-invite-store';
import { api } from './instance';

export function useDeclineInvite(options) {
  const { invite, setInvite } = useInviteStore();

  return useAsyncCallback(async ({ declineReason }) => {
    await api.auth.post('onlinebooking/decline-booking', {
      json: {
        bookingReference: invite.reference,
        statusReasonDescription: declineReason,
      },
    });
    setInvite({ status: INVITE_STATUS.CANCELLED });
  }, options);
}
